import { render, staticRenderFns } from "./reservationVoucher.vue?vue&type=template&id=047ae697"
import script from "./reservationVoucher.vue?vue&type=script&lang=js"
export * from "./reservationVoucher.vue?vue&type=script&lang=js"
import style0 from "./reservationVoucher.vue?vue&type=style&index=0&id=047ae697&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports